import { render, staticRenderFns } from "./evolucaoVendas.vue?vue&type=template&id=313a4f01"
import script from "./evolucaoVendas.ts?vue&type=script&lang=js&external"
export * from "./evolucaoVendas.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313a4f01')) {
      api.createRecord('313a4f01', component.options)
    } else {
      api.reload('313a4f01', component.options)
    }
    module.hot.accept("./evolucaoVendas.vue?vue&type=template&id=313a4f01", function () {
      api.rerender('313a4f01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/dashboard/evolucaoVendas.vue"
export default component.exports